<template>
  <div class="tarjeta">
    <div :class="tipo" class="cabecera">
      {{ titulo }}
    </div>
    <div class="cuerpo">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      required: true,
    },
    tipo: {
      type: String,
      required: false,
      default: "normal",
    },
  },
};
</script>

<style lang="scss" scoped>
.cabecera {
  font-size: 125%;
  margin-bottom: 1rem;
}
.naranja {
  color: $naranjaMMT;
  border-bottom: 2px solid $naranjaMMT;
}
.normal {
  color: $azulClaroMMT;
  border-bottom: 2px solid $azulClaroMMT;
}
</style>
